import styled from 'styled-components';

import { Flex, Grid, spaceMixin } from '@zillow/constellation';

export const StyledCompsSummaryContainer = styled.div`
  text-align: left;
  margin-right: ${spaceMixin('xs')};
`;

export const StyledRelativeGrid = styled(Grid)`
  overflow: hidden;
  position: relative;
  height: 125px;
`;

export const StyledOverflowFlex = styled(Flex)`
  overflow: hidden;
  height: 125px;
  width: 100%;

  > img {
    object-fit: cover;
  }
`;
